import React from 'react'
import axios from "../../network/api";
import { useState, useEffect } from "react";
import { baseUrl } from "../../network/Constants";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import "./Gallery.css";


function Viewmoreimage() {

    const [gallery, setGallery] = useState([]);
    const [loading, setLoading] = useState(false);
    


    useEffect(() => {
        fetchGallery();
      }, []);

      const fetchGallery = (props) => {
        setLoading(true)
        axios
          .get(baseUrl + "/app/gallery/")
          .then(async (response) => {
            setGallery(response.data);
            setLoading(false)
          })
          .catch((error) => {
            console.log(error);
            setLoading(false)
          });
      };


  return (

    
    <Container fluid>
        <div className="gallery-content">
          <Container>
            <div className="section-title pt-5">Photos</div>
          </Container>
          { loading ?  <div className="loader"><Spinner className="loading-color"/></div>: <Row className="gallery-images">
            {gallery.map((item, index) => {
              return (
                <>
                  <Col lg={4} className="gallery-image" key={index}>
                    <div className="gallery-overlay">
                      {/* <div className="gallery-overlay-year">{item.year}</div> */}
                    </div>
                    <img
                      src={item.gallery_image}
                      alt={`gallery-${index + 1}`}
                      className="img-fluid"
                    />
                  </Col>
                </>
              );
            })}
          </Row> }
          
        </div>
      </Container>
  )
}

export default Viewmoreimage;
